import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface CustomerShiftPeriod {
  shiftName: string;
  startHour: number;
  endHour: number;
}

export interface CustomerShiftConfigResponse {
  shiftHours: number;
  shiftPeriods: CustomerShiftPeriod[];
  showNaturalroad: boolean;
}

export interface CustomerShiftConfigState {
  loading: boolean;
  custCode?: string;
  data: CustomerShiftConfigResponse | null;
}

const initialState: CustomerShiftConfigState = {
  loading: false,
  custCode: undefined,
  data: null,
};

const customerShiftConfigSlice = createSlice({
  name: 'customerShiftConfig',
  initialState,
  reducers: {
    setCustomerShiftConfigLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setCustomerShiftConfigData(
      state,
      action: PayloadAction<{
        custCode: string;
        data: CustomerShiftConfigResponse;
      }>
    ) {
      state.custCode = action.payload.custCode;
      state.data = action.payload.data;
      state.loading = false;
    },
    resetCustomerShiftConfig(state) {
      state.loading = false;
      state.custCode = undefined;
      state.data = null;
    },
  },
});

export const {
  setCustomerShiftConfigLoading,
  setCustomerShiftConfigData,
  resetCustomerShiftConfig,
} = customerShiftConfigSlice.actions;

export default customerShiftConfigSlice.reducer;
